import axiosInstance from '../config/axios';

/**
 * Add a new enquiry / support question
 * Backend expects { question: "text" }
 * @param {Object|string} data - { question } or string
 */
export const addEnquiryApi = (data) => {
  const questionText = typeof data === 'string' ? data : (data.question || data.message || data.subject || '');
  return axiosInstance.post('/enquiry', { question: questionText }).then((res) => res.data);
};

/**
 * Fetch enquiry answers / user support enquiries list
 * Backend GET /enquiry returns { status: 200, data: [...] }
 */
export const getEnquiryAnswersApi = () =>
  axiosInstance.get('/enquiry').then((res) => res.data);

/**
 * Mark user's enquiry replies as read
 * Backend: PATCH /enquiry/read (with POST fallback)
 * @param {string} [enquiryId]
 */
export const markEnquiryReadApi = (enquiryId) => {
  return axiosInstance.patch('/enquiry/read', { enquiryId }).catch(() => {
    return axiosInstance.post('/enquiry/read', { enquiryId });
  }).then((res) => res.data);
};
